import type { ElementType } from 'react';

type Props = {
  actionLabel?: string;
  description: string;
  icon?: ElementType;
  onAction?: () => void;
  title: string;
};

export const EmptyState = ({ actionLabel, description, icon: Icon, onAction, title }: Props) => (
  <div className="empty-state">
    {Icon && (
      <span className="empty-state-icon" aria-hidden="true"><Icon size={25} /></span>
    )}
    <div>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
    {actionLabel && onAction && (
      <button type="button" className="secondary-button" onClick={onAction}>{actionLabel}</button>
    )}
  </div>
);

